import React from "react"
import Slider from "react-slick"
import { graphql } from 'gatsby'
import Scrollspy from 'react-scrollspy'
import Img from 'gatsby-image'
import { Link as ScrollLink } from 'react-scroll'
import Layout from "../components/layout"
import SEO from "../components/seo"
// import Newsletter from "../components/newsletter"
import { Link } from '../components/localizedlink'
import AutoAffix from '../utility/affix/AutoAffix'
import Highlighter from '../images/svg-icons/highlighter-light.svg'
import Tools from '../images/svg-icons/tools-light.svg'
import UsersClass from '../images/svg-icons/users-class-light.svg'
import PencilRuler from '../images/svg-icons/pencil-ruler-light.svg'
import SliderArrowRight from '../images/svg-icons/slider-arrow-right.svg'
// import Sponsor from '../components/sponsor'
import Banner from '../components/banner'
// import IIDModal from "../components/iid-modal"


const PrevArrow = ({ onClick, className }) => <button onClick={onClick} aria-label="prev" className={className}><SliderArrowRight /></button>;
const NextArrow = ({ onClick, className }) => <button onClick={onClick} aria-label="next" className={className}><SliderArrowRight /></button>;

const settings = {
  dots: false,
  arrows: true,
  infinite: true,
  centerMode: true,
  initialSlide: 1,
  slidesToShow: 2,
  slidesToScroll: 1,
  centerPadding: '10%',
  prevArrow: <PrevArrow />,
  nextArrow: <NextArrow />,
  responsive: [
    {
      breakpoint: 1300,
      settings: {
        slidesToShow: 2,
        centerPadding: '5%'
      }
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 1,
        centerPadding: '5%'
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 1,
        centerMode: false
      }
    }
  ]
};

const ChampionsPage = ({ pageContext: { locale }, data, location }) => (
  <Layout locale={locale} langPath={location.pathname}>
    <SEO title="Intranet Italia Champions" bodyClass="header-testata" />
    <section className="section evento evento--iic hero-testata">
      <Img className="evento__img" loading="eager" fluid={data.hero.childImageSharp.fluid} alt="" />
      <div className="container">
        <div className="row">
          <div className="col-12 text-center">
            <div className="hero-video__content">
              <div className="hero-intro hero-intro--iic">
                <div className="hero-intro__edition">3° Edizione</div>
                <div className="hero-intro__title text-uppercase" itemProp="name">Intranet Italia Champions</div>
                {/* <div className="hero-intro__date">19-20 maggio 2022</div> */}
                <div className="hero-intro__subject">Il premio per le migliori iniziative intranet italiane</div>
                <div className="hero-intro__claim">
                  Evento ideato da Giacomo Mason di <a href="https://www.intranetmanagement.it/" title="Intranet Management" target="_blank" rel="noopener noreferrer">Intranet Management</a>,  <br className="d-none d-lg-block" />azienda parte di <a href="https://www.ariadnegroup.it/" title="Ariadne Group" target="_blank" rel="noopener noreferrer">Ariadne Group</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div className="bg-fagioloni bg-fagioloni--offset bg-fagioloni--iic">
      <div className="bg-fagioloni__left"></div>
      <div className="bg-fagioloni__right"></div>

      <div id="champions" className="champions">
        <div className="container">
          <div className="row">
            <div className="d-none d-md-block col-md-5 col-lg-4 col-xl-3 text-center">
              <AutoAffix affixClassName="sidebar sidebar--affix" topClassName="sidebar sidebar--affix-top" bottomClassName="sidebar sidebar--affix-bottom"
                viewportOffsetTop={220} container={() => document.getElementById('scrollContainer')}>
                <div>
                  <div className="left-nav left-nav--primary">Che cos'&egrave; IIC</div>
                  <nav className="left-nav">
                    <Scrollspy items={['cose', 'partecipa', 'modalita', 'giuria', 'criteri', 'fasi', 'premio']} offset={-220}
                      className="" currentClassName="active">
                      <li className="left-nav__item">
                        <ScrollLink href="#cose" to="cose" smooth={true} title="Che cos'&egrave; l'IIC" className="left-nav__link">L'iniziativa</ScrollLink>
                      </li>
                      <li className="left-nav__item">
                        <ScrollLink href="#partecipa" to="partecipa" smooth={true} title="Per cosa puoi partecipare" className="left-nav__link">Per cosa puoi partecipare</ScrollLink>
                      </li>
                    </Scrollspy>
                  </nav>
                  <div className="left-nav left-nav--primary"><Link to="/report-iic-2020/#progetti">Report 2020</Link></div>
                  {/*
                  <div className="left-nav left-nav--primary"><Link to="/premio-iic-2019/#champions">Premio IIC 2019</Link></div>
                  */}
                  <div className="left-nav left-nav--primary"><Link to="/report-iic-2019/#vincitori">Report 2019</Link></div>
                </div>
              </AutoAffix>
            </div>
            <div className="col-md-7 col-lg-8 col-xl-9">
              <div className="champions__text" id="scrollContainer">
                <section id="banner" className="section">
                  <div className="row">
                    <div className="col-xl-9">
                      <h1 className="section__title"><strong>IIC<br />Intranet Italia Champions:</strong><br />
                      Le candidature per l’edizione 2021 sono chiuse.</h1>
                      <p>
                        Nell'ultimo anno hai gestito un progetto innovativo nell'ambito della comunicazione interna?
                      </p>
                      <p>
                        Hai realizzato un bella iniziativa di comunicazione o un contenuto davvero esplosivo all'interno della tua intranet?
                      </p>
                      <p>
                        Hai ideato una soluzione interessante per la collaboration, l'engagement o il miglioramento dei processi interni?
                      </p>
                      <p>
                        Hai creato una applicazione interna funzionale e di successo?
                      </p>
                      <p>
                        Se vuoi condividere i risultati con i colleghi di altre aziende, confrontarti ed essere di ispirazione per gli altri <strong>candida la tua azienda</strong>!
                      </p>
                      <p>
                        Per partecipare <strong>non &egrave; necessario presentare un grande progetto</strong>, basta anche <strong>un piccolo esempio</strong> di realizzazione all'interno della intranet: architettura dell'informazione, design, contenuti, progettazione, governance, funzioni social: in quale di questi ambiti ti sei cimentato?
                      </p>
                      <p>
                        Condividi con noi la tua esperienza e proponi il tuo progetto. <strong>Per iniziare bastano un paio di screenshot</strong>.
                      </p>
                    </div>
                  </div>
                </section>
                <section id="cose" className="section">
                  <div className="row">
                    <div className="col-xl-9">
                      <h1 className="section__title">Che cos'&egrave; l'Intranet Italia Champions</h1>
                      <div className="intro">
                        L'Intranet Italia Champions (IIC) &egrave; un riconoscimento annuale assegnato alle aziende che hanno implementato sulla propria Intranet un'<strong>iniziativa</strong>, un <strong>contenuto</strong>,
                        o una <strong>funzionalit&agrave;</strong> innovativa e di successo per l'azienda e per i dipendenti. Idee, contenuti utili, innovativi o presentati in modo nuovo, iniziative coinvolgenti e
                        partecipate, servizi utili e ben disegnati, funzionalit&agrave; e applicazioni innovative e che hanno prodotto risultati importanti per l'azienda e per i dipendenti.
                      </div>
                      <p>L'Intranet Italia Champions &egrave; promosso da <strong><a target="_blank" title="Intranet Management" href="https://www.intranetmanagement.it/" rel="noopener noreferrer">Intranet Management</a></strong>, in collaborazione con <strong><a target="_blank" title="Ariadne Digital" href="https://www.ariadnedigital.it/" rel="noopener noreferrer">Ariadne Digital</a></strong>.</p>
                      <p>Per cosa si concorre:</p>
                      <ul>
                        <li>i <strong>4 progetti migliori</strong> a giudizio della Giuria riceveranno il <strong>premio IIC2021</strong></li>
                        <li>i <strong>progetti</strong> che presentano elementi di interesse riceveranno una menzione da parte della Giuria.</li>
                      </ul>
                      <p>
                        Le descrizioni complete dei progetti vincitori e menzionati, corredate di screenshot, saranno inseriti all'interno del <strong>"Report Intranet Italia Champions 2021"</strong>, che verr&agrave; pubblicato a conclusione dell'iniziativa.
                      </p>
                    </div>
                  </div>
                </section>

                <section id="partecipa" className="section">
                  <div className="row">
                    <div className="col-xl-9">
                      <h1 className="section__title">Per cosa puoi partecipare</h1>
                      <p>
                        La giuria internazionale dell'Intranet Italia Champions valuterà singole funzionalità, contenuti o servizi online che hanno fatto la differenza
                        all'interno dell'organizzazione e della intranet. Saranno presi in considerazione quindi le seguenti 4 categorie:
                      </p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <Slider {...settings} className="slider-champions">
                        <div>
                          <div>
                            <Highlighter />
                            <h2>Contenuti e iniziative</h2>
                            <h4>(es. news, pagina, infografica, sezione, video, ecc.)</h4>
                            <p>
                              Contenuti particolarmente utili, rilevanti, innovativi o presentati in modo nuovo - ad esempio: news, avvisi, documenti, FAQ, infografiche, schede informative (prodotti, uffici, persone, settori eccetera), video gallery, contenuti formativi ben realizzati e distribuiti via intranet sui diversi supporti (desktop, tablet, mobile, digital signage). <br />
                              Iniziative di particolare rilevanza che hanno coinvolto la popolazione aziendale in modalità partecipative (ad esempio: idea management, contest, crowdsourcing, community, Q&amp;A eccetera).
                            </p>
                          </div>
                        </div>
                        <div>
                          <div>
                            <Tools />
                            <h2>Applicazioni e servizi</h2>
                            <h4>(es. prenotazioni, tool, app ecc.)</h4>
                            <p>
                              Servizi avanzati e utili realizzati con un design avanzato, quali, ad esempio: prenotazione sale, acquisto dotazioni, sistemi di ticketing, workflow approvativi, cerca persone, eccetera. Applicazioni ben disegnate, innovative ed integrate con la intranet, quali, ad esempio: applicazioni HR, formazione online, applicazioni di business, gestione ordini e magazzino, ecc.
                            </p>
                          </div>
                        </div>
                        <div>
                          <div>
                            <UsersClass />
                            <h2>Spazi social</h2>
                            <h4>(es. community, gruppi, ecc.)</h4>
                            <p>
                              Progetti intranet di interazione orizzontale e collaborazione tra colleghi: community, social network interni, gruppi di discussione, iniziative di crowdsourcing tra dipendenti, interazione orizzontale, in grado di creare valore per le persone e le organizzazioni. Non vengono considerati tanto gli strumenti tecnologici utilizzati, quanto il progetto nel suo complesso e i risultati ottenuti.
                            </p>
                          </div>
                        </div>
                        <div>
                          <div>
                            <PencilRuler />
                            <h2>Soluzioni di design</h2>
                            <h4>(visual design innovativo, restyling ad alto impatto ecc)</h4>
                            <p>
                              Tutto ciò che attiene all’esperienza degli utenti: architettura informativa, navigazione, modalità di filtro e personalizzazione e tutti gli elementi che garantiscono una digital experience di altro livello. <br />
                              Funzionalità innovative e realizzate con un design avanzato, quali, ad esempio: sistemi di ricerca, sistemi di notifica, sistemi di filtro, modalità di interazione con i dipendenti, sistemi di profilazione avanzata, sistemi di personalizzazione, pagine personali, eccetera.
                            </p>
                          </div>
                        </div>
                      </Slider>
                    </div>
                  </div>
                </section>

                {/* sezione temporanea */}
                <section className="section">
                  <div className="row pt-5">
                    <div className="col-12">
                      <p>Le candidature per l’edizione 2022 riapriranno a breve</p>
                    </div>
                  </div>
                </section>

                <Banner iic={true}/>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <Newsletter /> */}
    </div>
     {/* <IIDModal />*/}
  </Layout >
);

export default ChampionsPage;

export const query = graphql`
  query ChampionsQueryIta{
    hero: file(relativePath: { eq: "hero-iic.jpg"}) {
      childImageSharp {
        fluid(maxWidth: 1920, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    mason: file(relativePath: { eq: "contents/speaker/Giacomo_Mason.jpg"}){
      childImageSharp {
        fluid(maxWidth: 260, quality: 100){
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    mazzei: file(relativePath: { eq: "contents/speaker/Alessandra-Mazzei.jpg"}){
      childImageSharp {
        fluid(maxWidth: 260, quality: 100){
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    stancati: file(relativePath: { eq: "contents/speaker/Marco-Stancati.jpg"}){
      childImageSharp {
        fluid(maxWidth: 260, quality: 100){
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    bogdanova: file(relativePath: { eq: "contents/speaker/elena-bogdanova.jpg"}){
      childImageSharp {
        fluid(maxWidth: 260, quality: 100){
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    lustig: file(relativePath: { eq: "contents/speaker/Christiaan-Lustig.jpeg"}){
      childImageSharp {
        fluid(maxWidth: 260, quality: 100){
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    white: file(relativePath: { eq: "contents/speaker/Martin-White.jpg"}){
      childImageSharp {
        fluid(maxWidth: 260, quality: 100){
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`;
